import { Button, styled } from "@mui/material";

const DottedButton = styled(Button)(({ theme }) => ({
    borderRadius: 2,
    border: `1px dashed var(--green, ${theme.palette.primary.main})`,
    background: "rgba(5, 170, 151, 0.05)"
}));

export default DottedButton;
